import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appRecordCardGenericLeft]',
})
export class RecordCardGenericLeftDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
